import { SET_RECEIVER_NATIONAL_ID, CLEAR_RECEIVER_NATIONAL_ID } from '../actions/actionTypes';
import { ReceiverNationalIdAction } from '../actions/receiverNationalId';

export type ReceiverNationalIdReducer = {
    receiver_national_id: string;
    receiver_nid_region: string;
    receiver_nid_township: string;
    receiver_nid_type: string;
    receiver_nid_personal_id: string;
};

export type ReceiverNationalIdReducerState = {
    receiverNationalId: ReceiverNationalIdReducer;
};

const intialState: ReceiverNationalIdReducer = {
    receiver_national_id: '',
    receiver_nid_region: '',
    receiver_nid_township: '',
    receiver_nid_type: '',
    receiver_nid_personal_id: '',
};

const receiverNationalId = (state = intialState, action: ReceiverNationalIdAction): ReceiverNationalIdReducer => {
    switch (action.type) {
        case SET_RECEIVER_NATIONAL_ID:
            return {
                ...state,
                ...action.payload,
            };
        case CLEAR_RECEIVER_NATIONAL_ID:
            return intialState;
        default:
            return state;
    }
};

export default receiverNationalId;
